import { NotificationType } from '@repo/types/enums/notificationType';

import { Badge } from '@/components/ui/badge';

export interface NotificationTypeBadgeProps {
  type: NotificationType;
}

export default function NotificationTypeBadge(notificationTypeBadgeProps: NotificationTypeBadgeProps) {
  const { type } = notificationTypeBadgeProps;

  switch (type) {
    case NotificationType.Assignment:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Zadanie
        </Badge>
      );
    case NotificationType.Calendar:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Kalendarz
        </Badge>
      );
    case NotificationType.Chat:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Chat
        </Badge>
      );
    case NotificationType.Grade:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Ocena
        </Badge>
      );
    case NotificationType.Group:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Grupy
        </Badge>
      );
    case NotificationType.Fs:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Pliki
        </Badge>
      );
    case NotificationType.Post:
      return (
        <Badge size={'sm'} variant={'muted'}>
          Posty
        </Badge>
      );
  }
}
